import { render, staticRenderFns } from "./bao-cao-luu-kho.vue?vue&type=template&id=48623222&scoped=true&"
import script from "./bao-cao-luu-kho.vue?vue&type=script&lang=js&"
export * from "./bao-cao-luu-kho.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-luu-kho.vue?vue&type=style&index=0&id=48623222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48623222",
  null
  
)

export default component.exports